var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    {
      attrs: { active: _vm.isActive, "can-cancel": false },
      on: { close: _vm.closeCallback }
    },
    [
      _c(
        "sc-modal-card",
        { attrs: { title: "Excluir certificado digital" } },
        [
          _c("template", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "info-texts" }, [
              _c("p", [
                _vm._v("Tem certeza que deseja excluir o certificado digital?")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Ao excluir o certificado digital do selecionado, não iremos mais consultar os CT-es emitidos na SEFAZ."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Os CT-es já consultados continuarão disponíveis para consulta no TMS"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("sc-button", {
                attrs: { theme: "default", text: "Voltar", inverted: true },
                on: {
                  click: function() {
                    return _vm.closeCallback()
                  }
                }
              }),
              _vm._v(" "),
              _c("sc-button", {
                attrs: { theme: "danger", text: "Excluir certificado" },
                on: {
                  click: function() {
                    return _vm.excludeCallback()
                  }
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06ff2b9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ff2b9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-exclude-certificate-modal/ScExcludeCertificateModal.vue
// module id = null
// module chunks = 